
// tslint:disable-next-line: class-name
export class mapUniInfo {
    public static classType = m4m["mapUniInfo"] = mapUniInfo;
    public type: number = 0;
    public value: string = "";
    public valueKey: string = "";

}
